import {
  type Action,
  TrackObject,
  useAnalyticsTracker,
} from "./AnalyticsProvider";

export type ButtonTrackingEvent = {
  action: Action.PRESSED;
  extras: {
    id: string;
    type: string;
    label: string;
    section: string;
  } & Record<string, number | string>;
};

export const useButtonAnalytics = () =>
  useAnalyticsTracker<ButtonTrackingEvent>(TrackObject.BUTTON);
